/**
 * @description Status codes for empty bodies
 * @readonly
 * @type {number[]}
 */
const STATUS_CODE_EMPTY = [204, 205, 304];
Object.freeze(STATUS_CODE_EMPTY);
Object.seal(STATUS_CODE_EMPTY);
export { STATUS_CODE_EMPTY };
